<template>
  <b-col class="header">
    <b-container>
      <b-row class="header-row no-gutters">
        <b-col lg="1" class="d-md-none d-lg-block">&nbsp;</b-col>
        <b-col cols="5" sm="2" md="1" class="logo">
          <router-link to="/">
            <b-img
              src="https://db97aqbgbmp5i.cloudfront.net/images/fts.png"
              alt="Subastas FTS"
              fluid
            />
          </router-link>
        </b-col>
        <b-col cols="5" sm="6" md="4" lg="3" class="tagline">
          <router-link to="/">Club de Subastas</router-link>
        </b-col>
        <b-col md="1" class="menu-separator d-none d-md-block">&nbsp;</b-col>
        <b-col cols="2" sm="4" md="6" lg="5">
          <b-row class="no-gutters">
            <b-col class="menu-wrapper">
              <ul class="menu">
                <li class="featured">
                  <LoginBox />
                </li>
              </ul>
            </b-col>
          </b-row>
        </b-col>
        <b-col lg="1" class="d-md-none d-lg-block">&nbsp;</b-col>
      </b-row>
    </b-container>
  </b-col>
</template>

<script>
import LoginBox from "./session/LoginBox";
export default {
  name: "Header",
  components: {
    LoginBox,
  },
};
</script>

<style lang="scss" scoped>
@import "../assets/scss/partial";

.header {
  background-color: $black;
  padding: 2px 0;
  color: $white;

  @media (max-width: prev-viewport-max-size("md")) {
    font-size: 0.8rem;
  }

  a {
    color: $white;
  }
}

.header-row {
  > div {
    text-align: center;
    align-self: center;
  }
}

.tagline {
  font-size: 1.2em;
  font-weight: 700;
  text-transform: uppercase;

  @media (max-width: prev-viewport-max-size("xs")) {
    display: none;
  }

  a {
    &:hover,
    &:focus {
      text-decoration: none;
    }
  }
}

.menu-wrapper {
  display: flex;
  justify-content: center;
  align-items: flex-end;
}

ul.menu {
  flex: 1 0 auto;
  align-self: center;
  display: flex;
  justify-content: flex-end;
  list-style: none;
  margin: 0;
  padding: 0;

  @media (max-width: prev-viewport-max-size("md")) {
    flex-direction: column;
    align-self: flex-end;
  }

  li {
    list-style: none;
    text-transform: uppercase;
    margin-right: 30px;

    @media (max-width: prev-viewport-max-size("md")) {
      margin-right: 0;
      text-align: right;
    }

    &:last-child {
      margin-right: 0;
    }
  }
}
</style>
